import { useCallback, useRef } from 'react';

interface UseInfiniteScrollProps {
    hasNextPage: boolean;
    isFetchingNextPage: boolean;
    fetchNextPage: () => void;
    enabled?: boolean;
}

export const useInfiniteScroll = ({
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
    enabled = true
}: UseInfiniteScrollProps) => {
    const observer = useRef<IntersectionObserver | null>(null);

    const lastElementRef = useCallback((node: HTMLElement | null) => {
        if (isFetchingNextPage) return;
        if (observer.current) observer.current.disconnect();

        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && hasNextPage && enabled) {
                fetchNextPage();
            }
        }, {
            threshold: 0.1,
            rootMargin: '200px' // Cargar cuando esté a 100px del final
        });

        if (node) observer.current.observe(node);
    }, [isFetchingNextPage, hasNextPage, fetchNextPage, enabled]);

    return { lastElementRef };
}; 